module.exports = __webpack_public_path__ + "img/comming-soon.45b5cd62.svg";